// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"d4726752","257":"dea90ded","278":"a64c7319","284":"d4726752","528":"6aa99b0c","635":"d4726752","653":"842c19aa","718":"395009e2","735":"f804d754","904":"caf06cde"}[chunkId] + ".chunk.css";
};